/**
 * Method that checks including expression in the field
 *
 * @param {string} field
 * @param {string} exp
 * @return {boolean}
 */
export const includes = (field, exp) => field.trim().toLowerCase().includes(exp.trim().toLowerCase());